import { FormBaseDialog } from "components/parts/dialogs";
import { Button } from "@mui/material";

import { FormProvider, useForm } from "react-hook-form";
import { TextField, DialogContent, DialogActions } from "@mui/material";
import { IClassroomSchema, classroomSchema } from "./hooks/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormInput } from "components/parts/form";
import { useEffect } from "react";
import { useI18n } from "i18n";

type IClassroom = {
  id: number;
  roomNumber: string;
  name: string;
};

const clearData: IClassroomSchema = {
  name: "",
  roomNumber: "",
};

const ClassroomDialog = (props) => {
  const { open, editType, editData, handleClose, handleSubmit } = props;
  const { t } = useI18n();

  const methods = useForm<IClassroomSchema>({
    resolver: yupResolver(classroomSchema),
    defaultValues: clearData,
  });

  const { handleSubmit: formSubmit, reset, clearErrors } = methods;

  const onClose = () => {
    if(handleClose){
      handleClose();
      clearErrors();
      reset(clearData);
    }

  };

  const onSubmit = async (data) => {
    if (handleSubmit) {
      const resultSubmit = await handleSubmit(data);
      if (resultSubmit) {
        handleClose();
        reset(clearData);
      }
    }
  };

  useEffect(() => {
    console.log(editType, editData);
    reset(editData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editType, editData]);

  return (
    <FormBaseDialog
      open={open}
      handleClose={onClose}
      title={
        editType === "edit"
          ? t("classrooms.editTitle")
          : t("classrooms.addTitle")
      }
      content={
        <>
          <FormProvider {...methods}>
            <form onSubmit={formSubmit(onSubmit)}>
              <DialogContent>
                <FormInput
                  name="roomNumber"
                  render={(field, fieldState) => {
                    return (
                      <TextField
                        {...field}
                        label={t("field.roomNumber")}
                        type={"text"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        fullWidth
                        margin="dense"
                      />
                    );
                  }}
                />
                <FormInput
                  name="name"
                  render={(field, fieldState) => {
                    return (
                      <TextField
                        {...field}
                        label={t("field.roomName")}
                        type={"text"}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                        fullWidth
                        margin="dense"
                      />
                    );
                  }}
                />
              </DialogContent>
              <DialogActions>
                <>
                  <Button
                    onClick={() => {
                      onClose();
                    }}
                    color="primary"
                  >
                    {t("common.cancel")}
                  </Button>
                  <Button type="submit" color="primary">
                    {editType === "edit" ? t("common.update") : t("common.add")}
                  </Button>
                </>
              </DialogActions>
            </form>
          </FormProvider>
        </>
      }
    />
  );
};

export { ClassroomDialog };
export type { IClassroom };
